import React from 'react';
import { VehicleEventData } from '../../@types';
import styles from './TripFrameTop.styles';
import { useSelector } from 'react-redux';
import LinkToTrip from '../../components/shared/LinkToTrip';
import { selectCares } from '../../redux/store/userData/cares';
import {
  selectTripLoading,
  selectTrips,
} from '../../redux/store/userData/trips';
import LoadingIcon from '../shared/LoadingIcon';
import LinkToUser from '../shared/LinkToUser';

type TripFrameTopProps = {
  vehicleEvent: VehicleEventData;
};

const TripFrameTop: React.FC<TripFrameTopProps> = ({ vehicleEvent }) => {
  const trips = useSelector(selectTrips);
  const services = useSelector(selectCares);
  const isTripLoading = useSelector(selectTripLoading);
  const { userReferralCode, tripId, merchantRef, presentableTripId, userId } =
    vehicleEvent;
  const trip = trips?.find((trip) => tripId === trip.id);
  const service = services?.find((service) => tripId === service.id);
  const tripContractId = merchantRef
    ? ` (${merchantRef})`
    : !!trip && trip?.merchantRef
    ? ` (${trip?.merchantRef})`
    : !!service && service?.merchantRef
    ? ` (${trip?.merchantRef})`
    : '';

  return (
    <>
      <div className="wrapper">
        <p className="title">
          Trip
          <LinkToTrip
            tripId={tripId}
            tripCode={presentableTripId}
            service={service}
          />
          {tripContractId}
          {isTripLoading && <LoadingIcon font={14} />}
        </p>
        {(userId || userReferralCode) && (
          <div className="user-code">
            <span>by</span>
            <LinkToUser
              userId={userId}
              userCode={userReferralCode}
              label={userReferralCode}
            />
          </div>
        )}
      </div>

      <style jsx>{styles}</style>
    </>
  );
};

export default TripFrameTop;
